import {
  AfterViewInit,
  Component,
  isDevMode,
  OnInit,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { BaseComponent } from '@library-shared/base/base.component';
import { spAddress_State_ListX } from '@models/StoredProcs-Extended/spAddress_State_ListX';
import { spSite_Client_By_DomainX } from '@models/StoredProcs-Extended/spSite_Client_By_DomainX';
import { AddressService } from '@services/address/address.service';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { GlobalService } from '@services/global.service';
import { SiteService } from '@services/site/site.service';
import { TicketService } from '@services/ticket/ticket.service';
import { DxTextBoxComponent } from 'devextreme-angular';
import validationEngine from 'devextreme/ui/validation_engine';
import { ValidationCallbackData } from 'devextreme/ui/validation_rules';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: false,
})
export class SearchComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('summons_number_el') summons_number_el: DxTextBoxComponent;

  summons_number = '';
  plate_number = '';
  plate_state = '';
  license_number = '';
  license_state = '';
  last_name = '';
  dob: Date;

  invalidEntries = false;
  noTicketFound = false;
  technicalProblem = false;
  duplicateParking = false;
  duplicateTraffic = false;

  siteInfo: spSite_Client_By_DomainX;

  stateList: spAddress_State_ListX[] = [];
  readonly isDevelopmentMode = isDevMode();

  get set1(): boolean {
    return this.summons_number ? true : false;
  }

  get set2(): boolean {
    return this.plate_number || this.plate_state ? true : false;
  }

  get set3(): boolean {
    return this.license_number || this.license_state || this.last_name || this.dob ? true : false;
  }

  constructor(
    private addressService: AddressService,
    private authenticationService: AuthenticationService,
    private ticketService: TicketService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private siteService: SiteService,
    private globalService: GlobalService,
  ) {
    super();
    if (this.activatedRoute.snapshot.component === SearchComponent) {
      // this.log.data('Session_Start');
      this.authenticationService.Session_Start().subscribe({
        next: (data) => {
          this.globalService.authenticationToken = data.record.session_id;
          this.loadData();
        },
      });
      this.maintenanceCheck();
    }
    this.router.events.subscribe((e) => this.handleRouterEvents(e));
  }

  private maintenanceCheck() {
    this.siteService.Site_Info().subscribe({
      next: (data) => {
        if (data.success) {
          if (data.record.is_in_site_maintenance) {
            this.router.navigateByUrl('/maintenance');
          }
        }
      },
    });
  }

  ngOnInit() {
    //this.loadData();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.summons_number_el?.instance?.focus();
    }, 100);
  }

  searchEnterKeyPressed(e: any) {
    const valid = validationEngine.validateGroup(this.validationGroup);

    if (valid.isValid) {
      this.searchClick();
    }
  }

  resolved(captchaResponse: string) {
    this.log.data(`Resolved captcha with response: ${captchaResponse}`);
    if (typeof grecaptcha !== 'undefined') {
      const resp = grecaptcha.getResponse();
      this.log.data(`Resolved captcha with response: ${resp}`);
    }
  }

  handleRouterEvents(events: any) {
    // this.log.data('handleRouterEvents', events);
    if (events instanceof ActivationEnd) {
      const e: ActivationEnd = events;
      // this.log.data('ActivationEnd --- inactive --- ' + this.ticket_id, e);
      if (e.snapshot.component === SearchComponent) {
        // this.authenticationService.Session_Start().subscribe();
      }
    }
  }

  loadData() {
    this.isLoading2.set(true);
    this.siteService.Site_Info().subscribe({
      next: (site) => {
        this.siteInfo = site.record;
        this.addressService.Address_State_List().subscribe({
          next: (data) => {
            this.stateList = data.records.map((r) => new spAddress_State_ListX(r));
            this.isLoading2.set(false);
          },
        });
      },
    });
  }

  searchClick() {
    this.maintenanceCheck();
    this.resetErrors();
    if (!this.set1 && !this.set2 && !this.set3) {
      this.invalidEntries = true;
      return;
    }
    const valid = validationEngine.validateGroup(this.validationGroup);

    if (valid.isValid) {
      let recaptcha = 'dev-bypass';
      if (!this.isDevelopmentMode) {
        recaptcha = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse() : '';
        if (typeof grecaptcha !== 'undefined') {
          grecaptcha.reset();
        }
        if (recaptcha == '' || recaptcha == null) {
          return;
        }
      }

      this.isLoading2.set(true);
      this.ticketService
        .Ticket_Search({
          ticket_number: this.summons_number,
          plate_number: this.plate_number,
          plate_state: this.plate_state,
          license_number: this.license_number,
          license_state: this.license_state,
          last_name: this.last_name,
          dob: this.dob,
          recaptcha_token: recaptcha,
        })
        .subscribe({
          next: (data) => {
            if (data.success) {
              if (data.record.record_count > 0) {
                this.router.navigateByUrl('/ticketselect');
              } else {
                this.noTicketFound = true;
              }
            } else {
              this.technicalProblem = true;
            }
            this.isLoading2.set(false);
          },
        });
    }
  }

  resetErrors() {
    this.invalidEntries = false;
    this.noTicketFound = false;
    this.technicalProblem = false;
    this.duplicateParking = false;
    this.duplicateTraffic = false;
  }

  reset() {
    this.summons_number = null;
    this.plate_number = null;
    this.plate_state = null;
    this.license_number = null;
    this.license_state = null;
    this.last_name = null;
    this.dob = null;

    this.summons_number_el?.instance.focus();
    setTimeout(() => {
      validationEngine.resetGroup(this.validationGroup);
    });
  }

  searchValidation = (e: ValidationCallbackData) => {
    if (e.value == null) {
      return false;
    }
    return true;
  };
}
